<template>
  <div class="sort">
    <div class="sort-item" :class="{
      'is-active': !sortName
    }" @click="handleClear">
      <span class="text">综合排序</span>
    </div>

    <div v-for="(sort, index) in sortColumns" :key="sort.name" class="sort-item" :class="{
      'is-active': sort.name === sortName
    }">
      <span class="text" @click="onOrderClick(sort, index)">
        {{ sort.text }}
      </span>
      <div class="caret-wrapper" :class="[
        sort.name === sortName
          ? sortType == '4'
            ? 'ascending'
            : 'descending'
          : ''
      ]">
        <i class="sort-caret ascending"></i>
        <i class="sort-caret descending"></i>
      </div>
    </div>
  </div>
</template>

<script>
// import { createNamespacedHelpers } from "vuex";
// const { mapActions, mapMutations } = createNamespacedHelpers("product/list");

// const sortOrders = ["ascending", "descending", null];

// sort_name	否	sting	排序名称 1-综合 2-同行价 3-销量 4-利润 5-出发日期 默认1
// sort_type	否	string	排序方式 4-升序 3-降序 默认4

const MAP_SORT_TYPES = {
  ascending: "4",
  descending: "3",
};

const MAP_SORT_VALUE = {
  sale: "3",
  price: "2",
  profit: "4",
  date: "5",
  weight:"6",
  first_flight_time:"7"
};

const CRUISE_MAP_SORT_VALUE = {
  weight:"1",
  first_flight_time:"2"
};

const EVENT_NAME = "on-sort-change";

export default {
  name: "SortBar",
  props: {
    sortName: String,
    sortType: String,
    type:{
      type:String,
      default:'product'
    }
  },
  data() {
    return {
      productListColumns:[
        { name: MAP_SORT_VALUE.sale, text: "销量", order: "", props: {} },
        { name: MAP_SORT_VALUE.price, text: "价格", order: "", props: {} },
        { name: MAP_SORT_VALUE.profit, text: "利润", order: "", props: {} },
        { name: MAP_SORT_VALUE.date, text: "出发日期", order: "", props: {} },
      ],
      cruiseListColumns:[
        { name: CRUISE_MAP_SORT_VALUE.weight, text: "吨位", order: "", props: {} },
        { name: CRUISE_MAP_SORT_VALUE.first_flight_time, text: "首航时间", order: "", props: {} },
      ],
      // sortColumns: ,
      orderProp: "",
      order: "",
    };
  },
  computed:{
    sortColumns(){
      if( this.type === 'cruise_list' ){
        return this.cruiseListColumns;
      }else {
        return this.productListColumns;
      }
    }
  },
  methods: {
    onOrderClick(sort) {
      if (sort.name !== this.sortName) {
        this.$emit(EVENT_NAME, {
          sort_name: sort.name,
          sort_type: MAP_SORT_TYPES.ascending,
        });
      } else if (this.sortType === MAP_SORT_TYPES.descending) {
        this.handleClear();
      } else {
        this.$emit(EVENT_NAME, {
          sort_name: sort.name,
          sort_type:
            MAP_SORT_TYPES.ascending === this.sortType
              ? MAP_SORT_TYPES.descending
              : MAP_SORT_TYPES.ascending,
        });
      }
    },
    handleClear() {
      // this.orderProp = false;
      // this.order = false;
      // this.sortColumns = this.sortColumns.map(item => ({ ...item, order: "" }));

      this.$emit("on-sort-change", {
        sort_name: "",
        sort_type: "",
      });
      // this.setSearchData({
      //   sort_name: "",
      //   sort_type: ""
      // });
      // this.getProductList();
    },
  },
};
</script>

<style lang="scss" scoped>
.sort {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.sort-item:first-child {
  border-style: none;
}
.sort-item {
  border-left-width: 1px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-weight: 500;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  position: relative;
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
}
.sort-item.is-active .text {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(22, 53, 144, var(--tw-text-opacity));
}
.sort-item .caret-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 32px;
  width: 10px;
  vertical-align: middle;
  cursor: pointer;
  overflow: initial;
  position: relative;
  margin-left: 8px;
}
.sort-item .caret-wrapper .ascending {
  margin-bottom: 0.25rem;
}
.sort-item .sort-caret {
  width: 0;
  height: 0;
  border: solid 5px transparent;
  position: absolute;
}
.sort-item .sort-caret.ascending {
  border-bottom-color: currentColor;
  top: 5px;
}
.sort-item .sort-caret.descending {
  border-top-color: currentColor;
  bottom: 5px;
}
.sort-item .ascending .sort-caret.ascending {
  border-bottom-color: var( --color-primary);
}
.sort-item .descending .sort-caret.descending {
  border-top-color: var( --color-primary);
}
.css-icon {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  text-indent: -9999px;
  vertical-align: middle;
}
.css-icon::before, .css-icon::after {
  content: '';
  box-sizing: inherit;
  position: absolute;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.icon-caret-down::before {
  border: 0 solid transparent;
  border-top: 6px solid currentColor;
  transform: translate(-50%, -25%);
}
.icon-caret-up::before {
  border: 0 solid transparent;
  border-bottom: 6px solid currentColor;
  transform: translate(-50%, -25%);
}
</style>
